import styled from 'styled-components';

export const PolicyWrapper = styled.div`
    color: ${props => props.theme.colors.charcoal40};
    background-color: ${props => props.theme.colors.charcoal20};
    border: 1px solid ${props => props.theme.colors.ivorey};
    border-radius: 2px;
    font-size: 0.75em;
    line-height: 1.4;
    -webkit-overflow-scrolling: touch;
    overflow-y: auto;
    padding: 10px;
    word-break: break-all;
    max-height: 130px;
    height: 100%;

    * {
        font-size: 12px;
    }
`;
